import intl from "react-intl-universal";
import { TbApi, TbLink } from "react-icons/tb";
import { toPublicBaasApiBaseUrl } from "../../../../../Services/baasApiApi";
import { isBaasHmlInstance } from "../../../../../Services/baasInstancesApi";

const InfoRow = ({ label, children }) => (
  <div className="min-w-0">
    <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-400">{label}</p>
    <div className="mt-1 text-sm text-brand-dark dark:text-gray-100">{children}</div>
  </div>
);

export const BaasApiAccessPanel = ({ accessInfo, instance }) => {
  const environmentKey = isBaasHmlInstance(instance) ? "sandbox" : "production";
  const baseUrl = toPublicBaasApiBaseUrl(accessInfo?.baasBaseUrl);
  const isSandbox = environmentKey === "sandbox";

  return (
    <section className="min-w-0 overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
      <div className="border-b border-gray-100 px-4 py-3 dark:border-brand-dark-border">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-gray-200 bg-brand-cream/60 dark:border-brand-dark-border dark:bg-brand-dark-elevated">
            <TbApi className="h-4 w-4 text-brand-dark dark:text-gray-100" />
          </div>
          <div>
            <p className="text-sm font-semibold text-brand-dark dark:text-gray-100">
              {intl.get("baas.api.access.sectionTitle")}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {intl.get("baas.api.access.sectionSubtitle")}
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 px-4 py-4 sm:grid-cols-2 lg:grid-cols-4">
        <InfoRow label={intl.get("baas.api.access.baseUrl")}>
          {baseUrl ? (
            <div className="min-w-0">
              <a
                href={baseUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex max-w-full items-center gap-1.5 break-all text-[#a66f1d] hover:underline"
              >
                <TbLink className="h-3.5 w-3.5 shrink-0" />
                {baseUrl}
              </a>
              {isSandbox ? (
                <p className="mt-1 text-[11px] leading-snug text-gray-500 dark:text-gray-400">
                  {intl.get("baas.api.access.baseUrlSandboxHint")}
                </p>
              ) : null}
            </div>
          ) : (
            <span className="text-gray-500 dark:text-gray-400">
              {intl.get("baas.api.access.noBaseUrl")}
            </span>
          )}
        </InfoRow>

        <InfoRow label={intl.get("baas.api.access.instanceId")}>
          <code>{accessInfo?.instanceId ?? "—"}</code>
        </InfoRow>

        <InfoRow label={intl.get("baas.api.access.programCode")}>
          {accessInfo?.programCode || "—"}
        </InfoRow>

        <InfoRow label={intl.get("baas.api.access.environment")}>
          {intl.get(`baas.api.environment.${environmentKey}`)}
        </InfoRow>

        <InfoRow label={intl.get("baas.api.access.status")}>
          {accessInfo?.statusBadge || (accessInfo?.active ? intl.get("baas.api.access.active") : "—")}
        </InfoRow>
      </div>

      <div className="border-t border-amber-200/80 bg-amber-50/70 px-4 py-3 text-xs text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/20 dark:text-amber-200">
        {intl.get("baas.api.access.infoBox")}
      </div>
    </section>
  );
};
